import { defineTranslationScope } from "@app/shared/i18n/translation-scope";

export const scope = defineTranslationScope("navbar/navbar-plugins/navbar-new-version");
